var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.196 2.786a3.018 3.018 0 013.018 3.018v14.393a3.017 3.017 0 01-3.018 3.017H5.803a3.018 3.018 0 01-3.018-3.017V5.803a3.018 3.018 0 013.018-3.018h14.393zm1.625 6.038H4.178v11.373c0 .896.728 1.625 1.625 1.625h14.393a1.625 1.625 0 001.625-1.625V8.824zM8.124 16.251a1.161 1.161 0 110 2.322 1.161 1.161 0 010-2.322zm4.878 0a1.161 1.161 0 110 2.322 1.161 1.161 0 010-2.322zm-4.878-4.643a1.16 1.16 0 110 2.321 1.16 1.16 0 010-2.32zm4.878 0a1.16 1.16 0 110 2.322 1.16 1.16 0 010-2.322zm4.88 0a1.16 1.16 0 110 2.321 1.16 1.16 0 010-2.32zm2.314-7.43H5.803a1.625 1.625 0 00-1.625 1.626V7.43h17.643V5.804a1.625 1.625 0 00-1.625-1.625z",
    fill: "#333230"
  })));
}
export default SvgPldCalendar;